<form [formGroup]="form" (submit)="submit()" class="login">
  <div class="field">
    <label class="label" for="name">{{shared.res['#Username']}}</label>
    <input class="x-large input" id="name" #name type="text" formControlName="name" /><shared-tooltip [text]="shared.res['#tooltip_login_name']"></shared-tooltip>
  </div>
  <div class="field">
    <label class="label" for="name">{{shared.res['#Password']}}</label>
    <input class="x-large input" id="password" type="password" formControlName="password" /><shared-tooltip [text]="shared.res['#tooltip_login_password']"></shared-tooltip>
  </div>
  <div style="padding: 1rem 0;
    display: flex;
    align-items: center;">
    <a routerLink="/recover" [queryParams]="{name: form.value.name}" class="flex-grow">{{shared.res['#RecoverPasswordLink']}}</a>
    <button type="submit" class="button">{{shared.res['#Log in']}}</button>
  </div>
</form>
